'use strict';
class Cookies {
    static get(name) {
        const rgx = [
            '(?:(?:^|.*;)\\s*',
            encodeURIComponent(name).replace(/[-.+*]/g, '\\$&'),
            '\\s*\\=\\s*([^;]*).*$)|^.*$',
        ].join('');
        const val = decodeURIComponent(document.cookie.replace(new RegExp(rgx), '$1')) || null;
        if (val === null)
            return null;
        return val;
    }
    static set(name, val) {
        document.cookie = `${name}=${val}; path=/`;
    }
    static remove(name) {
        document.cookie = `${name}=; path=/`;
    }
}
export { Cookies };
export default Cookies;
//# sourceMappingURL=Cookies.js.map